import http from './request'

// 代理成长 获取用户信息
export const getAgentGrowthUserInfo = (data) => {
  return http({
    url: '/promotion/AgentGrowth/getUserInfo',
    method: 'post',
    data
  })
}

// 代理成长 获取任务列表
export const getAgentGrowthTaskList = (data) => {
  return http({
    url: '/promotion/AgentGrowthTask/getList',
    method: 'post',
    data
  })
}

// 代理成长 提交任务内容
export const submitAgentGrowthTask = (data) => {
  return http({
    url: '/promotion/AgentGrowthTask/submit',
    method: 'post',
    data
  })
}

// 代理成长 校验是否加入频道
export const checkAgentGrowthTaskJoinChannel = (data) => {
  return http({
    url: '/promotion/AgentGrowthTask/checkJoinChannel',
    method: 'post',
    data
  })
}

// 代理成长 任务领奖
export const receiveAgentGrowthTaskReward = (data) => {
  return http({
    url: '/promotion/AgentGrowthTask/receiveReward',
    method: 'post',
    data
  })
}
